import { render, staticRenderFns } from "./OrderRefund.vue?vue&type=template&id=2fd8dea9&scoped=true&"
import script from "./OrderRefund.vue?vue&type=script&lang=js&"
export * from "./OrderRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8dea9",
  null
  
)

export default component.exports